import React, { useEffect, useState } from 'react';
import firebaseConfig from '../../../Utilities/Firebase';
import { getDatabase, ref, set, onValue } from 'firebase/database'
import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from 'react-router'
import DataTable from 'react-data-table-component'
import { Button, InputGroup, FormControl } from 'react-bootstrap'
import generatePdf from "../GenerateLC/utils/GenerateLc"
import Navbars from '../../../Components/Navbar'

const FirebaseApp = initializeApp(firebaseConfig)
const db = getDatabase(FirebaseApp)

const PreviousLC = () => {
  const [data, setData] = useState([])
  const navigate = useNavigate();
  const [filterText, setFilterText] = useState('')

  const filteredData = data.filter(entry => {
    const values = Object.values(entry).map(item => item.toString().toLowerCase())
    return values.some(field => field.includes(filterText.toLowerCase()))
  })

  const deleteData = (sapId) => {

    try {
      set(ref(db, 'generated_lc/' + sapId), null)
    } catch (err) {
      console.log(err);
    }
  }


  useEffect(() => {

    IsUserLogedIn();

    const LeavingCertificates = ref(db, 'generated_lc/')
    onValue(LeavingCertificates, snapshot => {
      const data = snapshot.val()

      const transformed = Object.keys(data).map(key => ({
        ...data[key],
        firebaseKey: key,
      }))


      setData(transformed)
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const regenarateLCData = (e) => {
    generatePdf(e);
  }

  function IsUserLogedIn() {
    const FirebaseApp = initializeApp(firebaseConfig);
    const auth = getAuth(FirebaseApp);
    onAuthStateChanged(auth, (user) => {
      if (user === null) {
        navigate('/');
      }
    });
  }

  const Columns = [
    {
      name: 'SAP',
      wrap: true,
      sortable: true,
      selector: item => item['sap_id'],
    },
    {
      name: 'Name',
      wrap: true,
      sortable: true,
      selector: item => item['first_name'] + " " + item['last_name'],

    },
    {
      name: 'Department',
      wrap: true,
      sortable: true,
      selector: item => item['course'],

    },
    {
      name: 'Date',
      wrap: true,
      sortable: true,
      selector: item => item['date_of_admission'],

    },
    {
      name: 'Actions',
      wrap: true,
      cell: row => (
        <>
          <Button
            size="sm"
            variant="outline-dark"
            style={{
              marginRight: "13px",
              backgroundColor: "#aafdce",
              color: "black"
            }}
            onClick={(e) => {
              regenarateLCData(row);
            }}
          >
            Regenerate LC
          </Button>
          <Button
            size="sm"
            style={{
              backgroundColor: "#f8b2b2",
              color: "black"
            }}
            variant="outline-dark"
            onClick={() => {
              deleteData(row.sap_id)
            }}
          >
            Delete LC
          </Button>
        </>
      ),
    },
  ]



  return (
    <div>
      <Navbars type={'1'} />
      <div>
        <h1
          style={{
            color: '#636B65',
            marginTop: '5%',
            textAlign: 'center',
          }}
        >
          Leaving Certificate
        </h1>
        <h1>Generation History</h1>
        <InputGroup value={filterText} onChange={e => setFilterText(e.target.value)} className="mb-3">
          <InputGroup.Text id="inputGroup-sizing-default">Search</InputGroup.Text>
          <FormControl aria-label="Default" aria-describedby="inputGroup-sizing-default" />
        </InputGroup>
        <DataTable
          columns={Columns}
          data={filteredData}
          pagination
          paginationPerPage={10}
          paginationComponentOptions={{ noRowsPerPage: true }}
        />
      </div>
    </div>
  );
};

export default PreviousLC;